




























import Vue, { PropType } from 'vue'
import Group from '@/types/Group.interface'
export default Vue.extend({
    props: {
        group: {
            type: Object as PropType<Group>,
            required: true
        },
        unsubMsg: {
            type: String,
            default: null
        }
    },
    computed: {
        text(): string {
            if (!this.group.campaign_id) {
                return `These contact(s) will be removed from the group: <b>${this.group.name}</b> Do you wish to proceed?`
            }

            return `Are you sure you'd like to unsubscribe this contact from the autoresponder group: <b>${this.group.name}</b>? 
            When you unsubscribe this contact they will automatically receive the following message as a confirmation: 
            <b>"${this.unsubMsg}"</b>`
        }
    },
    methods: {
        cancel(): void {
            //  Close the dialog
            this.$emit('close')
        },
        remove(bool: boolean): void {
            //  Emit this to the callback
            this.$emit('submit', bool)
            //  Then close
            this.$emit('close')
        }
    }
})
